<template>
  <div class="page">
    <div class="page-content">

      <!-- <page-nav-bar
        currentServiceName="MoneyRoad"
        subNavTitle="Negotiate a Request to Pay"
        :closePage="isSmartphone">
      </page-nav-bar> -->

  		<div class="layoutTop"/>
      <div class="container-fluid">

      <div class="row">
            <div class="col-md-10 offset-md-1">
              <div class="panel21 panel-default">
                <div class="panel-heading">
                    <h4 class="content-block labelAccordionForm">
                        <img src='../../../assets/static/images/icons/inbox_into.png' class="formIcon"/>
                        Negotiate a Request to Pay
                    </h4>
                </div>

                <div class="accordion-item accordionForm">
                  <a href="#" class="item-content item-link text-uppercase" :class="colorBottomButton" @click="rotateChevron($event)">
                    <div class="item-inner">
                      <div class="form-group row justify-content-start">
                          <div class="item-title createInvoiceBand col-sm-auto">
                            Modifications
                            <i class="f7-icons formChevron">chevron_right</i>
                          </div>
                      </div>
                    </div>
                  </a>
                  <div class="accordion-item-content">
                    <div class="row justify-content-start">
                      <form-write-group-label-input :isMandatory="true"
                        :idLabel="$t('totalAmountLabel')" :placeholderValue="totalAmountLabel"
                        v-model="newAmount" :inputType="'number'" @change="checkSum">
                      </form-write-group-label-input>
                      <div class="form-group col-sm-6">
                        <label>
                          {{ $t('common.installment_number') }}
                        </label> <span class="color-red">* </span>
                        <select
                          class="form-control"
                          v-model="payNumber"
                          @change="defineArray(payNumber)">
                          <option v-for="n in 6" :min="1" :value="n">{{n}}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="accordion-item accordionForm">
                  <a href="#" class="item-content item-link text-uppercase" :class="colorBottomButton" @click="rotateChevron($event)">
                    <div class="item-inner">
                      <div class="form-group row justify-content-start">
                          <div class="item-title createInvoiceBand col-sm-auto">
                            Dates and Amounts
                            <i class="f7-icons formChevron">chevron_right</i>
                          </div>
                      </div>
                    </div>
                  </a>

                  <div class="accordion-item-content hasDatePicker">
                    <div class="row justify-content-start" v-if="!immediate" v-for="(n, index) in multPmts" :key="index">
                      <form-write-group-label-input :inputType="$t('date')" :formGroupWidth="'6 col-7'"
                        :idLabel="'common.installment_date'" v-model="payDate[index]">
                      </form-write-group-label-input>
                      <form-write-group-label-input :formGroupWidth="'6 col-5'" :isMandatory="true"
                          :idLabel="$t('common.amnt')" :placeholderValue="amountCurrency"
                          v-model="n.amount" :inputType="'number'">
                      </form-write-group-label-input>
                    </div>
                    <div class="form-group row">
                      <div class='col-sm-12'>
                        <f7-list-item>
                          <div v-if="!immediate" style="font-weight: bold; width: 100%; text-align:right;">
                            {{ $t('regles_metier.rqstng') }}
                            <font :color="sumColor">{{sum + ccy}}</font>
                            of
                            <font color="#12bcf1">{{newAmount + ccy}}</font>
                          </div>
                        </f7-list-item>
                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-sm-12">
                        <label>
                          {{ $t('common.general_comment') }}
                        </label>
                        <textarea style="font-size: 12px;" class="form-control" v-model="negotiationComment">
                      	</textarea>
                      </div>
                    </div>
                  </div>
                </div>
    </div>
  </div>
</div>
  <div class="row" :class="colorBottomButton">
    <div class="col-md-3 offset-md-8">
      <button round
      class="button-action firstButtonMarginTop"
      @click="submitToNegotiate">
      <i class="icon fa fa-paper-plane"></i>
        Send
      </button>
    </div>
  </div>
      <div class="toolbarPageBottomBlank"></div>
    </div>
  </div>
  </div>
</template>

<script>
// import {post} from '@/helpers/api'
import moment from 'moment'
import {errorMessageAlert} from '@/helpers/alert'
import pageNavBar from '@/components/common/pageNavBar.vue'
import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'
import datePickerMixin from '@/mixins/datePickerMixin'
import Datepicker from 'vuejs-datepicker'
import {loadPage} from '@/helpers/routing'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'

export default {
  mixins: [datePickerMixin],
  name: 'TransactionEdit',
  components: {
    'page-nav-bar': pageNavBar,
    'bottom-toolbar': bottomToolbar,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'date-picker': Datepicker
  },
  computed: {
    sum: function () {
      let sum = 0
      for (let i = 0; i < this.multPmts.length; i++) {
        sum += this.multPmts[i].amount === '' ? 0 : parseFloat(this.multPmts[i].amount)
      }
      return sum
    }
  },
  data () {
    return {
      isSmartphone: false,
      payNumber: 0,
      multPmts: [],
      payDate: [],
      payAmount: [],
      newAmount: 0,
      sumColor: 'red',
      amountChanged: false,
      immediate: false,
      ccy: '',
      negotiationComment: '',
      colorBottomButton: this.$engine.services.getButtonClassColorById(this.$engine.user.currentService.id),
      totalAmountLabel: this.$i18n.t('common.total_amount', {currency: this.$i18n.t('common.current_currency')}),
      amountCurrency: this.$i18n.t('common.amnt_with_currency', {currency: this.$i18n.t('common.current_currency')})
    }
  },
  watch: {
    sum (val) {
      if (Number(val) === Number(this.newAmount)) {
        this.sumColor = '#12bcf1'
      } else {
        this.sumColor = 'red'
      }
    },
    multPmts: {
      handler: function () {
        let flag = true
        let sum = 0
        for (let i = 0; i < (this.multPmts.length - 1); i++) {
          if (this.multPmts[i].amount > 0) {
            sum += parseFloat(this.multPmts[i].amount)
          } else {
            flag = false
            break
          }
        }

        if (flag && sum < this.newAmount) {
          this.multPmts[this.multPmts.length - 1].amount = this.newAmount - sum
        } else {
          this.multPmts[this.multPmts.length - 1].amount = 0
        }
      },
      deep: true
    }
  },
  created () {
    let that = this
    if (that.$engine.services.directPayments.filter.smartphoneStorage) {
      that.isSmartphone = true
    }
    if (that.$settings.clickedMessage.negotStatus === '0') {
      that.multPmts = []
      that.multPmts.push({date: that.$settings.clickedMessage.reqstdExecDt, amount: that.$settings.clickedMessage.amt})
      that.payNumber = 1
      that.payDate = []
      that.payDate.push(that.$settings.clickedMessage.reqstdExecDt)
      that.payAmount = []
      that.payAmount.push(that.$settings.clickedMessage.amt)
      // that.sum = that.$settings.clickedMessage.amt
      that.newAmount = that.$settings.clickedMessage.amt
    } else {
      that.multPmts = that.$settings.clickedMessage.pmtNegot.multiPayments
      that.payNumber = that.$settings.clickedMessage.pmtNegot.multiPayments.length
      that.payDate = []
      that.payAmount = []
      for (var i = 0; i < that.$settings.clickedMessage.pmtNegot.multiPayments.length; i++) {
        that.payDate.push(that.$settings.clickedMessage.pmtNegot.multiPayments[i].date)
        that.payAmount.push(that.$settings.clickedMessage.pmtNegot.multiPayments[i].amount)
      }
      // that.sum = that.$settings.clickedMessage.pmtNegot.amountDebtor
      that.newAmount = that.$settings.clickedMessage.pmtNegot.amountDebtor
    }
    that.amountChanged = false
    that.ccy = that.getCcy(that.$settings.clickedMessage.ccy)
    that.immediate = false
  },
  mounted () {
    /* TLV 23/06/2020
    * Sur toutes les tailles d'écran, les accordéons sont étendus par défaut
    */
    this.$$('.accordionForm').addClass('accordion-item-expanded')
    this.$$('.formChevron').transform('rotate(90deg)')
  },
  methods: {
    getCcy (ccy) {
      switch (ccy) {
        case 'EUR':
          return '€'
        case 'USD':
          return '$'
        case 'GBP':
          return '£'
        case 'JPY':
          return '¥'
        case 'RUB':
          return '₽'
        default:
          return this.$settings.clickedMessage.ccy
      }
    },
    defineArray (n) {
      this.payDate = []
      this.payAmount = []
      // this.sum = 0
      this.multPmts = []
      for (let i = 0; i < n; i++) {
        this.payDate.push(this.$settings.clickedMessage.reqstdExecDt)
        this.payAmount.push('')
        this.multPmts.push({
          date: this.payDate[i],
          amount: this.payAmount[i]
        })
      }
    },
    checkSum () {
      this.sumColor = 'red'
      if (this.sum > this.amount) {
        this.payAmount = []
      }
    },
    rotateChevron ($event) {
      if (this.Dom7($event.target).parent().parent().parent().parent().hasClass('accordion-item-expanded') ||
          this.Dom7($event.target).parent().parent().parent().hasClass('accordion-item-expanded') ||
          this.Dom7($event.target).parent().parent().hasClass('accordion-item-expanded') ||
          this.Dom7($event.target).parent().hasClass('accordion-item-expanded')) {
        this.Dom7($event.target).find('i').transform('rotate(0deg)')
      } else {
        this.Dom7($event.target).find('i').transform('rotate(90deg)')
      }
    },
    getColor () {
      if (Number(this.sum) === Number(this.newAmount)) {
        return 'green'
      } else {
        return 'red'
      }
    },
    submit () {
      let multiplePayments = []
      let execDate = ''
      let today = moment().format('YYYY-MM-DD')
      if (!this.immediate) {
        if (this.multPmts.length === 0) {
          this.$f7.alert('Please choose at least one date of payments', 'Invalid')
          return
        } else if (this.sum !== Number(this.newAmount)) {
          this.$f7.alert('The sum of all your pays must be equal to the total amount', 'Invalid')
          return
        }
        multiplePayments = this.multPmts
        execDate = this.multPmts[this.multPmts.length - 1].date
      } else {
        multiplePayments = []
        execDate = today
      }
      let that = this
      that.$engine.services.payments.answerToPayments(that.$settings.clickedMessage.id, '2', Number(this.newAmount), execDate, that.immediate, multiplePayments)
        .then(response => {
          if (response.status === 200) {
            that.$f7.alert('', 'Transaction Accepted', function () {
              that.$f7.closeModal()
              loadPage(that, {url: '/payments/inbox/'})
            })
          }
        })
        .catch(error => {
          errorMessageAlert(error, that)
        })
    },
    submitToNegotiate () {
      let that = this
      for (let i = 0; i < that.multPmts.length; i++) {
        console.log(that.payDate[i])
        that.multPmts[i].date = that.payDate[i]
      }
      let multiplePayments = []
      let execDate = ''
      if (this.multPmts.length === 0) {
        this.$f7.alert('Please, choose at least one date of payments', 'Invalid')
        return
      } else if (Number(this.sum) !== Number(this.newAmount)) {
        this.$f7.alert('The sum of all your pays must be equal to the total amount', 'Invalid')
        return
      }
      multiplePayments = this.multPmts
      let uniqueExecutionDate = []
      let flagUniqueExecutionDate = true
      for (let i = 0; i < multiplePayments.length; i++) {
        if (uniqueExecutionDate.includes(multiplePayments[i].date)) {
          flagUniqueExecutionDate = false
        } else {
          uniqueExecutionDate.push(multiplePayments[i].date)
        }
      }
      if (flagUniqueExecutionDate === false) {
        this.$f7.alert('Installment date should not be the same', 'Invalid')
        return
      }

      execDate = this.multPmts[0].date
      let negotiationType = ''
      let negotiationDecision = ''
      if (that.$settings.clickedMessage.negotStatus === '0') {
        negotiationType = 'negotRqst'
        negotiationDecision = 'OK'
      } else if (that.$settings.clickedMessage.negotStatus === '10') {
        negotiationType = 'negotResp'
        negotiationDecision = 'MODIF'
      }
      that.$engine.services.payments.negotiatePayments(
        that.$settings.clickedMessage.id,
        negotiationType,
        negotiationDecision,
        Number(this.newAmount),
        that.immediate,
        execDate,
        this.negotiationComment,
        multiplePayments
      ).then(response => {
        this.negotiationComment = ''
        if (response.status === 200) {
          let textAlert = ''
          if (that.$settings.clickedMessage.negotStatus === '0') {
            textAlert = 'Negotiation Request Sent'
          } else if (that.$settings.clickedMessage.negotStatus === '10') {
            textAlert = 'Negotiation Response Sent'
          } else {
            textAlert = ''
          }
          that.$f7.alert('', textAlert, function () {
            that.$f7.closeModal()
            if (that.$settings.clickedMessage.dir === '0') {
              loadPage(that, {url: '/payments/inbox/'})
            } else {
              loadPage(that, {url: '/payments/sendbox/'})
            }
          })
        }
      }).catch(error => {
        errorMessageAlert(error, that)
      })
    },
    calendar ($event, index) {
      /* eslint-disable no-undef */
      let that = this
      if (that.$f7.device.os === 'android' || that.$f7.device.os === 'ios') {
        var options = {
          date: new Date(),
          mode: 'date'
        }
        datePicker.show(options, function (date) {
          let year = date.getFullYear().toString()
          let month = (date.getMonth() + 1).toString().length > 1 ? (date.getMonth() + 1).toString() : '0' + (date.getMonth() + 1).toString()
          let day = date.getDate().toString().length > 1 ? date.getDate().toString() : '0' + date.getDate().toString()
          let dateResult = year + '-' + month + '-' + day
          that.payDate[index] = dateResult
          that.multPmts[index].date = dateResult
          // that.Dom7($event.target).val(dateResult)
          that.Dom7($event.target).text(dateResult)
        })
      }
      /* eslint-enable no-undef */
    },
    paymentsDate (index) {
      if (this.payDate[index] !== undefined) {
        if (this.payDate[index].length > 0) {
          return this.payDate[index]
        } else {
          return 'Select a date'
        }
      } else {
        return 'Select a date'
      }
    }
  }
}
</script>

<style>
#paymentsModification .item-title.label {
	overflow: initial;
  white-space: initial;
}
</style>



// WEBPACK FOOTER //
// CMTransactionEdit.vue?25e0a1dc